/* ----------------------------------------------------------------------------
   InterventionLayout — wraps every /intervention/* route:
     1. nested <ThemeProvider theme={interventionTheme}>
     2. <div className='intervention-scope'>
   The app's <Layout> still provides the real sidebar + topbar; this only skins
   the page content area.
   ---------------------------------------------------------------------------- */
import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import Box from '@mui/material/Box'
import interventionTheme from './theme'
import InterventionNav from './InterventionNav'
import './intervention-scoped.css'

export default function InterventionLayout({ children }) {
  return (
    <ThemeProvider theme={interventionTheme}>
      <Box
        className='intervention-scope'
        sx={{
          minHeight: 'calc(100vh - 60px)',
          bgcolor: 'background.default',
          color: 'text.primary',
          p: { xs: 2, md: 3 },
        }}
      >
        <InterventionNav />
        <Box sx={{ mt: 2 }}>{children}</Box>
      </Box>
    </ThemeProvider>
  )
}
